/**
 * buildTime — surfaces the date the site was last built/deployed so the UI
 * can show a "Last updated" cue that stays fresh automatically.
 *
 * The value is stamped at build time via REACT_APP_BUILD_DATE, which the
 * CI buildspec sets to the current UTC time right before `npm run build`.
 * Because every deploy runs a fresh build, the date re-stamps on every
 * deploy with no runtime fetch. In local dev (env var unset) we fall back
 * to the current wall-clock time.
 */
const raw = process.env.REACT_APP_BUILD_DATE;
export const buildDate = raw && !Number.isNaN(Date.parse(raw)) ? new Date(raw) : new Date();

/**
 * Human-readable formatting for the "Last updated" badge.
 *   format='short'   -> "July 2026"
 *   format='medium'  -> "July 24, 2026"
 *   format='iso'     -> "2026-07-24"
 */
export function formatBuildDate(format = 'medium') {
  if (Number.isNaN(buildDate.getTime())) return '';
  if (format === 'iso') return buildDate.toISOString().slice(0, 10);
  if (format === 'short') {
    return buildDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
  }
  return buildDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
